import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Interchangeables } from '../StockPage'
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Pagination,
  Card,
  CardTitle,
  CardContent,
} from '@airbus/components-react/components'
import LightDarkContext from 'context/LightDarkModeContext'

const StockInterchangeableTable = ({
  interchangeables,
  onPaginateInterchangeable,
}: {
  interchangeables: Interchangeables | null
  onPaginateInterchangeable: (s: number, p: number) => void
}) => {
  const { t } = useTranslation()

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    onPaginateInterchangeable(parseInt(event.target.value), 1)
  }
  const { getBackgroundColor } = useContext(LightDarkContext)

  return (
    <div style={{ width: '100%' }}>
      <Card
        style={{
          maxWidth: 'none',
          width: '100%',
          marginBottom: '20px',
          padding: '10px',
          backgroundColor: getBackgroundColor(),
        }}
      >
        <CardContent>
          <CardTitle id='tableTitle'>{t('7009181')}</CardTitle>
          <Table style={{ minWidth: 750 }} aria-labelledby='tableTitle'>
            <TableHead>
              <TableRow>
                <TableCell>{t('9500047')}</TableCell>
                <TableCell>{t('7000248')}</TableCell>
                <TableCell>{t('7000270')}</TableCell>
                <TableCell>{t('7001147')}</TableCell>
                <TableCell>{t('7001180')}</TableCell>
                <TableCell>{t('9500190')}</TableCell>
                <TableCell>{t('1P00425')}</TableCell>
                <TableCell>{t('9500191')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {interchangeables?.content ? (
                interchangeables.content.map((row) => (
                  <TableRow hover tabIndex={-1} key={row.pn}>
                    <TableCell component='th' scope='row' style={{ padding: '0 0 0 16px' }}>
                      {row.pn}
                    </TableCell>
                    <TableCell>{row.designation}</TableCell>
                    <TableCell>{row.codFab}</TableCell>
                    <TableCell>{row.codeInter}</TableCell>
                    <TableCell align='right'>{row.stock}</TableCell>
                    <TableCell align='right'>{row.stockAppro}</TableCell>
                    <TableCell>{row.numdoc}</TableCell>
                    <TableCell>{row.status}</TableCell>
                  </TableRow>
                ))
              ) : (
                <div style={{ textAlign: 'center' }}>{t('9500055')}</div>
              )}
            </TableBody>
          </Table>

          {interchangeables && (
            <Pagination
              rowsPerPageOptions={[5, 10, 20, 50]}
              component='div'
              count={interchangeables.totalElements}
              rowsPerPage={interchangeables.size}
              page={interchangeables.number + 1}
              onPageChange={(_, page) => onPaginateInterchangeable(interchangeables.size, page)}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageLabel={t('entries_per_page')}
            />
          )}
        </CardContent>
      </Card>
    </div>
  )
}

export default StockInterchangeableTable
